// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TimeToggleController from "./time_toggle_controller"
application.register("time-toggle", TimeToggleController)

import TimeFromNowController from "./time_from_now_controller"
application.register("time-from-now", TimeFromNowController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import DocumentBucketsController from "./document_buckets_controller"
application.register("document-buckets", DocumentBucketsController)

import ImageFallbackController from "./image_fallback_controller"
application.register("image-fallback", ImageFallbackController)

import CelebrationController from "./celebration_controller"
application.register("celebration", CelebrationController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import QrRefreshController from "./qr_refresh_controller"
application.register("qr-refresh", QrRefreshController)

import PyrotechnicsController from "./pyrotechnics_controller"
application.register("pyrotechnics", PyrotechnicsController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)

import EmailDrawerController from "./email_drawer_controller"
application.register("email-drawer", EmailDrawerController)

import AttachmentPreviewController from "./attachment_preview_controller"
application.register("attachment-preview", AttachmentPreviewController)

import DateSliderController from "./date_slider_controller"
application.register("date-slider", DateSliderController)

import DepreciationChartController from "./depreciation_chart_controller"
application.register("depreciation-chart", DepreciationChartController)

import PhotoHighlightController from "./photo_highlight_controller"
application.register("photo-highlight", PhotoHighlightController)

import SyntaxHighlightController from "./syntax_highlight_controller"
application.register("syntax-highlight", SyntaxHighlightController)

import CommentTypeController from "./comment_type_controller"
application.register("comment-type", CommentTypeController)

import LexxyAttachmentFallbackController from "./lexxy_attachment_fallback_controller"
application.register("lexxy-attachment-fallback", LexxyAttachmentFallbackController)

import LinkUnfurlController from "./link_unfurl_controller"
application.register("link-unfurl", LinkUnfurlController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import AlertRibbonController from "./alert_ribbon_controller"
application.register("alert-ribbon", AlertRibbonController)

import DashboardAlertsController from "./dashboard_alerts_controller"
application.register("dashboard-alerts", DashboardAlertsController)

import PurchaseLocationController from "./purchase_location_controller"
application.register("purchase-location", PurchaseLocationController)

import CoveragePeriodController from "./coverage_period_controller"
application.register("coverage-period", CoveragePeriodController)

import TermStatusController from "./term_status_controller"
application.register("term-status", TermStatusController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import PasswordValidationController from "./password_validation_controller"
application.register("password-validation", PasswordValidationController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import UrlReplaceController from "./url_replace_controller"
application.register("url-replace", UrlReplaceController)

import MobileTabsController from "./mobile_tabs_controller"
application.register("mobile-tabs", MobileTabsController)

import DetailsAnchorController from "./details_anchor_controller"
application.register("details-anchor", DetailsAnchorController)
